<ion-header class="ion-no-border">

  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-button (click)="close()">
        <fa-icon [icon]="['far', 'times']" size="lg" [fixedWidth]="true" slot="start"></fa-icon>
      </ion-button>
    </ion-buttons>
    <ion-title>
      Edit
      @if (payment) {
        <p class="subtitle">Payment #{{payment.number}}</p>
      }
    </ion-title>
    @if (online && !loading) {
      <ion-buttons slot="end">
        <ion-button (click)="update()">
          <fa-icon [icon]="['far', 'check']" size="lg" [fixedWidth]="true" slot="start"></fa-icon>
        </ion-button>
      </ion-buttons>
    }
  </ion-toolbar>

</ion-header>

<ion-content>

  @if (online && !loading) {
    <ion-grid class="form">
      <ion-row>
        <ion-col>
          <ion-grid class="fieldset">
            <ion-row>
              <ion-col>
                @if (params['date']) {
                  <ion-input class="modal-input" readonly="true" label="Date" labelPlacement="stacked" fill="outline" value={{formatted_date}} (click)="presentDateTimePickerModal()"></ion-input>
                }
                @if (!params['date']) {
                  <ion-input class="modal-input" readonly="true" label="Date" labelPlacement="stacked" fill="outline" (click)="presentDateTimePickerModal()"></ion-input>
                }
              </ion-col>
            </ion-row>
            @if (payment && payment.method == 'custom') {
              <ion-row>
                <ion-col>
                  <ion-input type="text" inputmode="text" maxlength="50" labelPlacement="stacked" fill="outline" [(ngModel)]="params['payment_service_transaction_id']">
                    <div slot="label">Transaction ID<ion-text class="optional">optional</ion-text></div>
                  </ion-input>
                </ion-col>
              </ion-row>
            }
          </ion-grid>
        </ion-col>
      </ion-row>
    </ion-grid>
  }

</ion-content>